import React from 'react';
import { Button } from 'core/components';

const intentMap = {
  Destination: 'primary',
  Source: 'warning',
  'Source or Dest': 'danger',
  Full: 'success'
};

function DimensionButton({ option, ...rest }) {
  const intent = option ? intentMap[option.group || 'Full'] : 'danger';
  const hasGroup = option && option.group && option.group !== 'none';

  const text = option ? (
    <>
      {hasGroup && option.group} {option.tagLabel || option.label}
    </>
  ) : (
    'Invalid Selection'
  );

  return <Button intent={intent} text={text} {...rest} />;
}

export default DimensionButton;
